export function generateStandardSpan(width, sensitive) {
  let span = Math.ceil(24 / Math.trunc(width / sensitive))
  if (span >= 24) {
    //避免无穷大页面卡死
    span = 24
  }
  if (span !== 0) {
    while (24 % span !== 0) {
      span--;
    }
  } else {
    span = 1;
  }
  return span;

}



// WEBPACK FOOTER //
// ./src/utils/acquireStandardSpan.js